import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../../store"
import { Symbols } from "@tenforce/toolbox-fontmap"

import BookmarkConfigWidget from "./BookmarkConfigWidget"
import ConfigWidget from "./ConfigWidget"
import { Labels } from "../../../../util/Translations"
import { Bookmark, IGridTile, IShortcut } from "../../../../models"

interface OwnProps {
    tile: IGridTile
    isDragging: boolean
    removeTile: (tileId: number) => void
}

interface StateProps {
    bookmarks: Record<string, Bookmark>
    shortcuts: Record<string, IShortcut>
}

type Props = OwnProps & StateProps

export class DraggableWidget extends React.Component<Props> {
    render(): JSX.Element {
        const { Content, Workspaces, Shortcut } = Labels

        const { tile, bookmarks, shortcuts, isDragging, removeTile } =
            this.props

        const classes = `theme-thumb has-hidden-actions is-draggable-y bg-cloud ${
            isDragging ? "tw-rounded theme-float" : ""
        }`

        if (tile.type === "Bookmark" && !!bookmarks[tile.bookmarkId]) {
            const bookmark = bookmarks[tile.bookmarkId]
            return (
                <div
                    className={classes}
                    data-ft-component="widget"
                    data-ft-tile-id={tile.id}
                    data-ft-widget-type="bookmark"
                    data-ft-bookmark-id={tile.bookmarkId}
                    data-ft-bookmark-title={bookmark.title}
                >
                    <BookmarkConfigWidget
                        bookmark={bookmark}
                        tileId={tile.id}
                        key={tile.id}
                        removeTile={removeTile}
                    />
                </div>
            )
        } else if (tile.type === "Shortcut" && !!shortcuts[tile.shortcutId]) {
            const shortcut = shortcuts[tile.shortcutId]
            return (
                <div
                    className={classes}
                    data-ft-component="widget"
                    data-ft-tile-id={tile.id}
                    data-ft-widget-type="shortcut"
                    data-ft-shortcut-id={tile.shortcutId}
                    data-ft-shortcut-title={shortcut.title}
                >
                    <ConfigWidget
                        icon={Symbols.ArrowForward}
                        label={Shortcut}
                        title={shortcut.title}
                        key={tile.id}
                    />
                </div>
            )
        } else if (tile.type === "WorkspaceContent") {
            return (
                <div
                    className={classes}
                    data-ft-component="widget"
                    data-ft-tile-id={tile.id}
                    data-ft-widget-type="content"
                >
                    <ConfigWidget
                        icon={Symbols.Cards}
                        title={Content}
                        key={tile.id}
                    />
                </div>
            )
        } else if (tile.type === "WelcomePageContent") {
            return (
                <div
                    className={classes}
                    data-ft-component="widget"
                    data-ft-tile-id={tile.id}
                    data-ft-widget-type="workspaces"
                >
                    <ConfigWidget
                        icon={Symbols.Cards}
                        title={Workspaces}
                        key={tile.id}
                    />
                </div>
            )
        }

        return <></>
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    bookmarks: state.bookmarks.bookmarks,
    shortcuts: state.shortcuts.shortcuts,
})

export default connect(mapStateToProps, {})(DraggableWidget)
